import React from 'react';
import PropTypes from 'prop-types';

/**
 * Layout sin topbar/footer: credenciales, herramientas internas, pantalla completa.
 */
const Blank = ({ children }) => (
  <div style={{ minHeight: '100vh', margin: 0, padding: 0 }}>{children}</div>
);

Blank.propTypes = {
  children: PropTypes.node,
};

export default Blank;
